/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './reset-password.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/auth/reset-password/reset-password.component';
import * as i3 from '@angular/forms';
import * as i4 from '../../shared/loading-indicator/loading-indicator.component.ngfactory';
import * as i5 from '../../../../app/shared/loading-indicator/loading-indicator.component';
import * as i6 from '@angular/router';
import * as i7 from '@angular/common';
import * as i8 from '../../../../app/shared/translations/translate.directive';
import * as i9 from '../../../../app/shared/translations/translations.service';
import * as i10 from '../../../../app/shared/settings.service';
import * as i11 from '../../../../app/auth/auth.service';
import * as i12 from '../../../../app/shared/toast/toast.service';
const styles_ResetPasswordComponent:any[] = [i0.styles];
export const RenderType_ResetPasswordComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_ResetPasswordComponent,data:{}});
function View_ResetPasswordComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',[['class',
      'error email-error']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.errors.email;
    _ck(_v,1,0,currVal_0);
  });
}
function View_ResetPasswordComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'p',[['class',
      'error password-error']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.errors.password;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ResetPasswordComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),80,'form',[['class',
      'auth-page'],['novalidate','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
      [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
          (null as any)]],[[(null as any),'ngSubmit'],[(null as any),'submit'],[(null as any),
      'reset']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.ResetPasswordComponent = _v.component;
    if (('submit' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,2).onSubmit($event)) !== false);
      ad = (pd_0 && ad);
    }
    if (('reset' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,2).onReset()) !== false);
      ad = (pd_1 && ad);
    }
    if (('ngSubmit' === en)) {
      const pd_2:any = ((<any>_co.resetPassword()) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.ɵbf,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i3.NgForm,[[8,(null as any)],
      [8,(null as any)]],(null as any),{ngSubmit:'ngSubmit'}),i1.ɵprd(2048,(null as any),
      i3.ControlContainer,(null as any),[i3.NgForm]),i1.ɵdid(16384,(null as any),0,
      i3.NgControlStatusGroup,[i3.ControlContainer],(null as any),(null as any)),(_l()(),
      i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      73,'div',[['class','many-inputs auth-panel']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'loading-indicator',[['class',
          'overlay']],(null as any),(null as any),(null as any),i4.View_LoadingIndicatorComponent_0,
          i4.RenderType_LoadingIndicatorComponent)),i1.ɵdid(573440,(null as any),0,
          i5.LoadingIndicatorComponent,[i1.ElementRef],{isVisible:[0,'isVisible']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),3,'a',[['class','logo']],[[1,'target',
              0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,12).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i6.RouterLinkWithHref,
          [i6.Router,i6.ActivatedRoute,i7.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          0,'img',[['alt','logo']],[[8,'src',4]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),18,'div',[['class','input-container']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),2,'label',[['class','hidden'],['for','email'],['trans','']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(4341760,(null as any),0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,
          i10.SettingsService],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['Email'])),(_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),8,'input',[['id','email'],['name','email'],['placeholder',
              'Email'],['required',''],['trans-placeholder',''],['type','email']],
          [[1,'required',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ResetPasswordComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,23)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,23).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,23)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,23)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>(_co.model.email = $event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i3.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i3.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i3.RequiredValidator]),i1.ɵprd(1024,(null as any),i3.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i3.NgModel,[[2,
          i3.ControlContainer],[2,i3.NG_VALIDATORS],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i3.NgControl,(null as any),[i3.NgModel]),i1.ɵdid(16384,(null as any),
          0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),i1.ɵdid(4341760,
          (null as any),0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,i10.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ResetPasswordComponent_1)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),18,'div',[['class','input-container']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'label',
          [['class','hidden'],['for','password'],['trans','']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(4341760,(null as any),
          0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,i10.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['New Password'])),
      (_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),8,'input',[['id','password'],['name','password'],['placeholder',
              'Password'],['required',''],['trans-placeholder',''],['type','password']],
          [[1,'required',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ResetPasswordComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,43)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,43).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,43)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,43)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>(_co.model.password = $event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i3.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i3.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i3.RequiredValidator]),i1.ɵprd(1024,(null as any),i3.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i3.NgModel,[[2,
          i3.ControlContainer],[2,i3.NG_VALIDATORS],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i3.NgControl,(null as any),[i3.NgModel]),i1.ɵdid(16384,(null as any),
          0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),i1.ɵdid(4341760,
          (null as any),0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,i10.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ResetPasswordComponent_2)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),
          i1.ɵted((null as any),['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),15,'div',[['class','input-container']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'label',
          [['class','hidden'],['for','password_confirmation'],['trans','']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(4341760,
          (null as any),0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,i10.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['Confirm New Password'])),
      (_l()(),i1.ɵted((null as any),['\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),8,'input',[['id','password_confirmation'],['name','password_confirmation'],
              ['placeholder','Confirm Password'],['required',''],['trans-placeholder',
                  ''],['type','password']],[[1,'required',0],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ResetPasswordComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,63)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,63).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,63)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,63)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>(_co.model.password_confirmation = $event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i3.RequiredValidator,([] as any[]),
          {required:[0,'required']},(null as any)),i1.ɵprd(1024,(null as any),i3.NG_VALIDATORS,
          (p0_0:any) => {
            return [p0_0];
          },[i3.RequiredValidator]),i1.ɵprd(1024,(null as any),i3.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i3.NgModel,[[2,
          i3.ControlContainer],[2,i3.NG_VALIDATORS],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i3.NgControl,(null as any),[i3.NgModel]),i1.ɵdid(16384,(null as any),
          0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),i1.ɵdid(4341760,
          (null as any),0,i8.TranslateDirective,[i1.ElementRef,i9.Translations,i10.SettingsService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),5,'div',[['class','right']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n            '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'button',[['class','button primary submit-button'],
          ['trans',''],['type','submit']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(4341760,(null as any),0,i8.TranslateDirective,
          [i1.ElementRef,i9.Translations,i10.SettingsService],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['Reset Password'])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),
          ['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i2.ResetPasswordComponent = _v.component;
    const currVal_7:any = _co.isLoading;
    _ck(_v,9,0,currVal_7);
    const currVal_10:any = _ck(_v,13,0,'/');
    _ck(_v,12,0,currVal_10);
    const currVal_20:any = '';
    _ck(_v,24,0,currVal_20);
    const currVal_21:any = 'email';
    const currVal_22:any = _co.model.email;
    _ck(_v,27,0,currVal_21,currVal_22);
    const currVal_23:any = _co.errors.email;
    _ck(_v,33,0,currVal_23);
    const currVal_32:any = '';
    _ck(_v,44,0,currVal_32);
    const currVal_33:any = 'password';
    const currVal_34:any = _co.model.password;
    _ck(_v,47,0,currVal_33,currVal_34);
    const currVal_35:any = _co.errors.password;
    _ck(_v,53,0,currVal_35);
    const currVal_44:any = '';
    _ck(_v,64,0,currVal_44);
    const currVal_45:any = 'password_confirmation';
    const currVal_46:any = _co.model.password_confirmation;
    _ck(_v,67,0,currVal_45,currVal_46);
  },(_ck,_v) => {
    var _co:i2.ResetPasswordComponent = _v.component;
    const currVal_0:any = i1.ɵnov(_v,4).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,4).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,4).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,4).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,4).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,4).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,4).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = i1.ɵnov(_v,12).target;
    const currVal_9:any = i1.ɵnov(_v,12).href;
    _ck(_v,11,0,currVal_8,currVal_9);
    const currVal_11:any = _co.settings.get('branding.site_logo');
    _ck(_v,14,0,currVal_11);
    const currVal_12:any = (i1.ɵnov(_v,24).required? '': (null as any));
    const currVal_13:any = i1.ɵnov(_v,29).ngClassUntouched;
    const currVal_14:any = i1.ɵnov(_v,29).ngClassTouched;
    const currVal_15:any = i1.ɵnov(_v,29).ngClassPristine;
    const currVal_16:any = i1.ɵnov(_v,29).ngClassDirty;
    const currVal_17:any = i1.ɵnov(_v,29).ngClassValid;
    const currVal_18:any = i1.ɵnov(_v,29).ngClassInvalid;
    const currVal_19:any = i1.ɵnov(_v,29).ngClassPending;
    _ck(_v,22,0,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,
        currVal_18,currVal_19);
    const currVal_24:any = (i1.ɵnov(_v,44).required? '': (null as any));
    const currVal_25:any = i1.ɵnov(_v,49).ngClassUntouched;
    const currVal_26:any = i1.ɵnov(_v,49).ngClassTouched;
    const currVal_27:any = i1.ɵnov(_v,49).ngClassPristine;
    const currVal_28:any = i1.ɵnov(_v,49).ngClassDirty;
    const currVal_29:any = i1.ɵnov(_v,49).ngClassValid;
    const currVal_30:any = i1.ɵnov(_v,49).ngClassInvalid;
    const currVal_31:any = i1.ɵnov(_v,49).ngClassPending;
    _ck(_v,42,0,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,
        currVal_30,currVal_31);
    const currVal_36:any = (i1.ɵnov(_v,64).required? '': (null as any));
    const currVal_37:any = i1.ɵnov(_v,69).ngClassUntouched;
    const currVal_38:any = i1.ɵnov(_v,69).ngClassTouched;
    const currVal_39:any = i1.ɵnov(_v,69).ngClassPristine;
    const currVal_40:any = i1.ɵnov(_v,69).ngClassDirty;
    const currVal_41:any = i1.ɵnov(_v,69).ngClassValid;
    const currVal_42:any = i1.ɵnov(_v,69).ngClassInvalid;
    const currVal_43:any = i1.ɵnov(_v,69).ngClassPending;
    _ck(_v,62,0,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40,currVal_41,
        currVal_42,currVal_43);
  });
}
export function View_ResetPasswordComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'reset-password',
      ([] as any[]),(null as any),(null as any),(null as any),View_ResetPasswordComponent_0,
      RenderType_ResetPasswordComponent)),i1.ɵdid(49152,(null as any),0,i2.ResetPasswordComponent,
      [i11.AuthService,i10.SettingsService,i6.ActivatedRoute,i6.Router,i12.ToastService],
      (null as any),(null as any))],(null as any),(null as any));
}
export const ResetPasswordComponentNgFactory:i1.ComponentFactory<i2.ResetPasswordComponent> = i1.ɵccf('reset-password',
    i2.ResetPasswordComponent,View_ResetPasswordComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/auth/reset-password/reset-password.component.ngfactory.ts